'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = undefined;
var _systemComponents = require('system-components');
var _systemComponents2 = _interopRequireDefault(_systemComponents);
var _gridStyled = require('grid-styled');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Banner = exports.Banner = (0, _systemComponents2["default"])({
  is: _gridStyled.Flex,
  p: [3, 4],
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  minHeight: '80vh',
  color: 'white',
  bg: 'dark'
}, 'minHeight', 'backgroundSize', 'backgroundPosition', 'backgroundImage');
Banner.displayName = 'Banner';
exports["default"] = Banner;